// import React, { useState, useEffect } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { IoClose } from 'react-icons/io5';
// import { FaPrint } from 'react-icons/fa';
// import { GoPackage } from 'react-icons/go';
// import { MdOutlinePayment } from 'react-icons/md';
// import apiClient from '../../Api/apiClient';
// import { PHOTO_BASE_URL } from '../../Api/config';
// import SubscriberDetailsBG from '../../Assets/images/SubscriberDetailsBG.png'
// import Printicon from '../../Assets/icon/Printicon.png';
// const SubscriberDetails = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [subscriberInfo, setSubscriberInfo] = useState({});
//   const [packageInfo, setPackageInfo] = useState({});
//   const [paymentDetails, setPaymentDetails] = useState({});
//    const userType = localStorage.getItem('user_type');
//    console.log('usertype in publish tender form:', userType);

//   useEffect(() => {
//     const fetchSubscriberDetails = async () => {
//       try {
//            const apiEndpoint =
//              userType === 'end_user'
//                ? `/user/tender-end-user/bill-status-details/${id}`
//                : userType === 'user'
//                ? `/user/tender-user/bill-status-details/${id}`
//                : '';
//         const response = await apiClient.get(
//           // `/user/tender-end-user/bill-status-details/${id}`
//           apiEndpoint
//         );
//         const data = response.data;
//         console.log("Subscriber details data:", data);

//         setSubscriberInfo({
//           user_name: data?.data?.user_name || 'N/A',
//           phone: data?.data?.phone || 'N/A',
//           email: data?.data?.email || 'N/A',
//           designation: data?.data?.designation || 'N/A',
//           Organization_name: data?.data?.organization_name || 'N/A',
//           address: data?.data?.address || 'N/A',
//           city: data?.data?.city || 'N/A',
//           photo: data?.data?.photo || '',
//         });

//         setPackageInfo({
//           package_Id: data?.data?.package_id || 'N/A',
//           package_Name: data?.data?.package_name || 'N/A',
//           package_Duration: data?.data?.package_duration || 'N/A',
//           package_Amount: data?.data?.pay_amount || 'N/A',
//           package_Start_Time: data?.data?.package_start_date || 'N/A',
//           package_End_Time: data?.data?.package_expired_date || 'N/A',
//         });

//         setPaymentDetails({
//           order_Id: data?.data?.order_id || 'N/A',
//           transaction_Id: data?.data?.tran_id || 'N/A',
//           account: data?.data?.acc_number || 'N/A',
//           customer_Phone_Number: data?.data?.cus_phone_no || 'N/A',
//           initiate_At: data?.data?.initiate_at || 'N/A',
//           payment_Status: data?.data?.payment_status || 'N/A',
//           sp_Order_Id: data?.data?.sp_order_id || 'N/A',
//           store_Id: data?.data?.store_id || 'N/A',
//           invoice_No: data?.data?.invoice_no || 'N/A',
//           payment_Method: data?.data?.method || 'N/A',
//           payment_Time_Status: data?.data?.payment_time || 'N/A',
//           status: data?.data?.status || 'N/A',
//           received_Amount: data?.data?.recived_amount || 'N/A',
//           card_Holder_Name: data?.data?.card_holder_name || 'N/A',
//           usd_Rate: data?.data?.usd_rate || 'N/A',
//           bank_Status: data?.data?.bank_status || 'N/A',
//           usd_Amount: data?.data?.usd_amount || 'N/A',
//           discount: data?.data?.discount_amount || 'N/A',
//         });
//       } catch (error) {
//         console.error('Error fetching subscriber details:', error);
//       }
//     };

//     if (id) fetchSubscriberDetails();
//   }, [id]);

//   const handleGoBack = () => navigate(-1);

//     const handlePrint = () => {
//       window.print(); // This will open the print dialog
//     };

//   return (
//     <div className="bg-white min-h-screen md:p-6 p-2 container mx-auto mt-36  text-xs 2xl:text-sm">
//       {/* Header Section */}
//       <div className="bg-white border p-6 rounded-lg shadow-md flex flex-col md:flex-row items-center justify-between">
//         {/* User Info */}
//         <div className="flex items-center">
//           <img
//             src={
//               subscriberInfo.photo
//                 ? `${PHOTO_BASE_URL}${subscriberInfo.photo}`
//                 : 'https://via.placeholder.com/100'
//             }
//             alt=""
//             className="w-20 h-20 rounded-full border"
//           />
//           <div className="ml-4">
//             <div className="flex items-center justify-between mb-2">
//               <h1 className="text-xl font-semibold">
//                 {subscriberInfo.user_name}
//               </h1>
//               <button onClick={handlePrint} className="md:hidden block">
//                 {/* <IoClose size={24} /> */}
//                 <img src={Printicon} alt="" />
//               </button>
//             </div>

//             <p className="text-sm text-gray-500">
//               📞 {subscriberInfo.phone} | 📧 {subscriberInfo.email}
//             </p>
//             <p className="text-sm text-gray-500">
//               📍 {subscriberInfo.address}, {subscriberInfo.city}
//             </p>
//           </div>
//         </div>

//         {/* Company Info */}
//         <div className="mt-4 md:mt-0 text-justify">
//           <p className="font-medium text-gray-700">Company Info</p>
//           <p className="text-sm text-gray-500">
//             {subscriberInfo.Organization_name}
//           </p>
//           <p className="text-sm text-gray-500">{subscriberInfo.designation}</p>
//         </div>

//         <button
//           onClick={handlePrint}
//           className="border p-2 rounded-md md:block hidden"
//         >
//           {/* <IoClose size={24} /> */}
//           <img src={Printicon} alt="" />
//         </button>
//       </div>

//       {/* Package Information */}
//       <div
//         className="bg-white border md:p-6 p-0 mt-6 rounded-lg shadow-md flex justify-center items-center"
//         // className="w-full bg-center bg-cover relative bg-no-repeat"
//         style={{ backgroundImage: `url(${SubscriberDetailsBG})` }}
//       >
//         <div className="w-full max-w-2xl  bg-[#f6faff] md:p-6 p-2 rounded-lg shadow-md">
//           <h2 className="text-lg font-semibold text-gray-800 flex mb-4 justify-center items-center">
//             <GoPackage className="mr-2" />
//             Package Information
//           </h2>
//           <div className="border p-4 rounded-md bg-[#f6faff]">
//             {Object.entries(packageInfo).map(([key, value]) => (
//               <div className="flex justify-between mb-4" key={key}>
//                 <p>
//                   <strong>{key.replace(/_/g, ' ')}:</strong>
//                 </p>
//                 <p>{value}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Payment Transaction Details */}
//       <div className="bg-[#fffbf5] border md:p-6  p-2 mt-6 rounded-lg shadow-md">
//         <h2 className="text-lg font-semibold text-gray-800 flex mb-4 justify-center items-center">
//           <MdOutlinePayment className="mr-2" />
//           Payment Transaction Details
//         </h2>
//         {/* <div className="border p-4 text-xs 2xl:text-sm rounded-md bg-white grid grid-cols-1 md:grid-cols-2 gap-4">
//           {Object.entries(paymentDetails).map(([key, value]) => (
//             <div className="flex justify-between mb-4" key={key}>
//               <p>
//                 <strong>{key.replace(/_/g, ' ')}:</strong>
//               </p>
//               <p>{value}</p>
//             </div>
//           ))}
//         </div> */}
//         <div className="border md:p-4 p-2  rounded-md bg-white grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-x-10">
//           {Object.entries(paymentDetails).map(([key, value]) => (
//             <div
//               className="flex justify-between p-4 border rounded-md bg-gray-50"
//               key={key}
//             >
//               <p>
//                 <strong>{key.replace(/_/g, ' ')}:</strong>
//               </p>
//               <p>{value}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SubscriberDetails;

import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IoClose } from 'react-icons/io5';
import { FaPrint } from 'react-icons/fa';
import { GoPackage } from 'react-icons/go';
import { MdOutlinePayment } from 'react-icons/md';
import apiClient from '../../Api/apiClient';
import { PHOTO_BASE_URL } from '../../Api/config';
import SubscriberDetailsBG from '../../Assets/images/SubscriberDetailsBG.png';
import Printicon from '../../Assets/icon/Printicon.png';
import { format, parseISO } from "date-fns";


const SubscriberDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subscriberInfo, setSubscriberInfo] = useState({});
  const [packageInfo, setPackageInfo] = useState({});
  const [paymentDetails, setPaymentDetails] = useState({});
  const userType = localStorage.getItem('user_type');
  console.log('usertype in publish tender form:', userType);





  const formatDate = (dateString) => {
    if (!dateString) return "N/A"; // Jodi date undefined hoy tahole "N/A" return korbe
    try {
      return format(parseISO(dateString), "dd-MMM-yyyy"); // Date ta ISO format theke parse kore dd-MMM-yyyy format kora holo
    } catch {
      return "N/A"; // Jodi kono unexpected error hoy
    }
  };


  useEffect(() => {
    const fetchSubscriberDetails = async () => {
      try {
        const apiEndpoint =
          userType === 'end_user'
            ? `/user/tender-end-user/bill-status-details/${id}`
            : userType === 'user'
              ? `/user/tender-user/bill-status-details/${id}`
              : '';
        const response = await apiClient.get(apiEndpoint);
        const data = response.data;
        console.log('Subscriber details data:', data);

        setSubscriberInfo({
          user_name: data?.data?.user_name || 'N/A',
          phone: data?.data?.phone || 'N/A',
          email: data?.data?.email || 'N/A',
          designation: data?.data?.designation || 'N/A',
          Organization_name: data?.data?.organization_name || 'N/A',
          address: data?.data?.address || 'N/A',
          city: data?.data?.city || 'N/A',
          photo: data?.data?.photo || '',
        });



        setPackageInfo({
          Package_ID: data?.data?.package_id || 'N/A',
          Package_Name: data?.data?.package_name || 'N/A',
          // package_Duration: data?.data?.package_duration || 'N/A',
          package_Duration: data?.data?.package_duration
            ? `${data?.data?.package_duration} Month`
            : 'N/A', // Static Month
          // package_Amount: data?.data?.pay_amount || 'N/A',
          Package_Amount: data?.data?.pay_amount
            ? `${data?.data?.pay_amount} BDT`
            : 'N/A', // Add BDT
          Package_Start_Time: data?.data?.package_start_date || 'N/A',
          Package_End_Time: data?.data?.package_expired_date || 'N/A',



        });

        setPaymentDetails({
          Order_ID: data?.data?.order_id || 'N/A',
          Transaction_ID: data?.data?.tran_id || 'N/A',
          Account: data?.data?.acc_number || 'N/A',
          Customer_Phone_Number: data?.data?.cus_phone_no || 'N/A',
          Initiate_At: data?.data?.initiate_at || 'N/A',
          Payment_Status: data?.data?.payment_status || 'N/A',
          Sp_Order_ID: data?.data?.sp_order_id || 'N/A',
          Store_ID: data?.data?.store_id || 'N/A',
          Invoice_No: data?.data?.invoice_no || 'N/A',
          Payment_Method: data?.data?.method || 'N/A',
          Payment_Time_Status: data?.data?.payment_time || 'N/A',
          Status: data?.data?.status || 'N/A',
          Received_Amount: data?.data?.recived_amount || 'N/A',
          Card_Holder_Name: data?.data?.card_holder_name || 'N/A',
          Usd_Rate: data?.data?.usd_rate || 'N/A',
          Bank_Status: data?.data?.bank_status || 'N/A',
          Usd_Amount: data?.data?.usd_amount || 'N/A',
          Discount: data?.data?.discount_amount || 'N/A',
        });
      } catch (error) {
        console.error('Error fetching subscriber details:', error);
      }
    };

    if (id) fetchSubscriberDetails();
  }, [id]);

  const handleGoBack = () => navigate(-1);

  const handlePrint = () => {
    window.print(); // This will open the print dialog
  };

  return (
    <div className="bg-white min-h-screen md:p-6 p-2 container mx-auto mt-36 text-xs 2xl:text-sm">
      {/* Header Section */}
      {/* <div className="bg-white border p-6 rounded-lg shadow-md flex flex-col md:flex-row items-center justify-between">
        
        <div className="flex items-center">
          <img
            src={
              subscriberInfo.photo
                ? `${PHOTO_BASE_URL}${subscriberInfo.photo}`
                : 'https://via.placeholder.com/100'
            }
            alt=""
            className="w-20 h-20 rounded-full border"
          />
          <div className="ml-4">
            <div className="flex items-center justify-between mb-2">
              <h1 className="text-xl font-semibold">{subscriberInfo.user_name}</h1>
              <button onClick={handlePrint} className="md:hidden block">
                <img src={Printicon} alt="" />
              </button>
            </div>
            <p className="text-sm text-gray-500">
              📞 {subscriberInfo.phone} | 📧 {subscriberInfo.email}
            </p>
            <p className="text-sm text-gray-500">
              📍 {subscriberInfo.address}, {subscriberInfo.city}
            </p>
          </div>
        </div>

        
        <div className="mt-4 md:mt-0 text-justify">
          <p className="font-medium text-gray-700">Company Info</p>
          <p className="text-sm text-gray-500">{subscriberInfo.Organization_name}</p>
          <p className="text-sm text-gray-500">{subscriberInfo.designation}</p>
        </div>
        


        <button onClick={handlePrint} className="border p-2 rounded-md md:block hidden">
          <img src={Printicon} alt="" />
        </button>
      </div> */}
      <div className="bg-white border p-6 rounded-lg shadow-md flex flex-col md:flex-row items-center justify-between">
        {/* User Info */}
        <div className="flex items-center">
          <img
            src={
              subscriberInfo.photo
                ? `${PHOTO_BASE_URL}${subscriberInfo.photo}`
                : 'https://via.placeholder.com/100'
            }
            alt=""
            className="w-20 h-20 rounded-full border"
          />
          <div className="ml-4">
            <div className="flex items-center justify-between mb-2">
              {subscriberInfo.user_name !== 'N/A' &&
                subscriberInfo.user_name !== null && (
                  <h1 className="text-xl font-semibold">
                    {subscriberInfo.user_name}
                  </h1>
                )}
              <button onClick={handlePrint} className="md:hidden block">
                <img src={Printicon} alt="" />
              </button>
            </div>

            {subscriberInfo.phone !== 'N/A' &&
              subscriberInfo.phone !== null && (
                <p className="text-sm text-gray-500">
                  📞 {subscriberInfo.phone}
                </p>
              )}
            {subscriberInfo.email !== 'N/A' &&
              subscriberInfo.email !== null && (
                <p className="text-sm text-gray-500">
                  📧 {subscriberInfo.email}
                </p>
              )}
            {subscriberInfo.address !== 'N/A' &&
              subscriberInfo.address !== null && (
                <p className="text-sm text-gray-500">
                  📍 {subscriberInfo.address}
                </p>
              )}
            {subscriberInfo.city !== 'N/A' && subscriberInfo.city !== null && (
              <p className="text-sm text-gray-500">{subscriberInfo.city}</p>
            )}
          </div>
        </div>

        {/* Company Info */}
        <div className="mt-4 md:mt-0 text-justify">
          <p className="font-medium text-gray-700">Company Info</p>
          {subscriberInfo.Organization_name !== 'N/A' &&
            subscriberInfo.Organization_name !== null && (
              <p className="text-sm text-gray-500">
                {subscriberInfo.Organization_name}
              </p>
            )}
          {subscriberInfo.designation !== 'N/A' &&
            subscriberInfo.designation !== null && (
              <p className="text-sm text-gray-500">
                {subscriberInfo.designation}
              </p>
            )}
        </div>

        <button
          onClick={handlePrint}
          className="border p-2 rounded-md md:block hidden"
        >
          <img src={Printicon} alt="" />
        </button>
      </div>

      {/* Package Information */}
      <div
        className="bg-white border md:p-6 p-0 mt-6 rounded-lg shadow-md flex justify-center items-center"
        style={{ backgroundImage: `url(${SubscriberDetailsBG})` }}
      >
        <div className="w-full max-w-2xl bg-[#f6faff] md:p-6 p-2 rounded-lg shadow-md">
          <h2 className="text-lg font-semibold text-gray-800 flex mb-4 justify-center items-center">
            <GoPackage className="mr-2" />
            Package Information
          </h2>
          {/* <div className="border p-4 rounded-md bg-[#f6faff]">
            {Object.entries(packageInfo).map(
              ([key, value]) =>
                value !== 'N/A' &&
                value !== null && (
                  <div className="flex justify-between mb-4" key={key}>
                    <p>
                      <strong>{key.replace(/_/g, ' ')}:</strong>
                    </p>
                    <p>{value}</p>
                  </div>
                )
            )}
          </div> */}
          <div className="border p-4 rounded-md bg-[#f6faff]">
            {Object.entries(packageInfo).map(([key, value]) => {
              // Check if the value is a date string
              const formattedValue = key.toLowerCase().includes("time")
                ? formatDate(value) // If the key has "time", format the value as a date
                : value;

              return (
                formattedValue !== "N/A" && formattedValue !== null && (
                  <div className="flex justify-between mb-4" key={key}>
                    <p>
                      <strong>{key.replace(/_/g, " ")}:</strong>
                    </p>
                    <p>{formattedValue}</p>
                  </div>
                )
              );
            })}
          </div>

        </div>
      </div>

      {/* Payment Transaction Details */}
      <div className="bg-[#fffbf5] border md:p-6 p-2 mt-6 rounded-lg shadow-md">
        <h2 className="text-lg font-semibold text-gray-800 flex mb-4 justify-center items-center">
          <MdOutlinePayment className="mr-2" />
          Payment Transaction Details
        </h2>
        {/* <div className="border md:p-4 p-2 rounded-md bg-white grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-x-10">
          {Object.entries(paymentDetails).map(
            ([key, value]) =>
              value !== 'N/A' &&
              value !== null && (
                <div
                  className="flex justify-between p-4 border rounded-md bg-gray-50"
                  key={key}
                >
                  <p>
                    <strong>{key.replace(/_/g, ' ')}:</strong>
                  </p>
                  <p>{value}</p>
                  
                </div>
              )
          )}
        </div> */}

        <div className="border md:p-4 p-2 rounded-md bg-white grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-x-10">
          {Object.entries(paymentDetails).map(([key, value]) => {
            // Conditional Status Display
            if (key === 'Status') {
              // Handle both number and string comparison
              value =
                value === 1 || value === '1'
                  ? 'Verified'
                  : value === 0 || value === '0'
                    ? 'Non-verified'
                    : value;
            }

            // Conditional "Received Amount"
            if (key === 'Received_Amount' && value !== 'N/A') {
              value = `${value} BDT`;
            }

            // Hide Usd Rate and Discount if value is 0 or '0'
            if ((key === 'Usd_Rate' || key === 'Discount') && (value == 0 || value == '0')) {
              return null; // Skip rendering this item if value is 0 or '0'
            }

            // Format the date fields if the key matches
            if (key === 'Payment_Time_Status' || key === 'Initiate_At') {
              value = formatDate(value); // Apply the date format
            }

            // Apply color to Status
            const statusClass =
              value === 'Verified'
                ? 'text-green-500' // Green color for Verified
                : value === 'Non-verified'
                  ? 'text-red-500' // Red color for Non-verified
                  : '';

            return (
              value !== 'N/A' && value !== null && (
                <div className="flex justify-between p-4 border rounded-md bg-gray-50" key={key}>
                  <p>
                    <strong>{key.replace(/_/g, ' ')}:</strong>
                  </p>
                  <p className={statusClass}>{value}</p>
                </div>
              )
            );
          })}
        </div>








      </div>
    </div>
  );
};

export default SubscriberDetails;
